import { render, staticRenderFns } from "./AstaImpostazioni.vue?vue&type=template&id=cd37229e&scoped=true&"
import script from "./AstaImpostazioni.vue?vue&type=script&lang=js&"
export * from "./AstaImpostazioni.vue?vue&type=script&lang=js&"
import style0 from "./AstaImpostazioni.vue?vue&type=style&index=0&id=cd37229e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd37229e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd37229e')) {
      api.createRecord('cd37229e', component.options)
    } else {
      api.reload('cd37229e', component.options)
    }
    module.hot.accept("./AstaImpostazioni.vue?vue&type=template&id=cd37229e&scoped=true&", function () {
      api.rerender('cd37229e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/AstaImpostazioni.vue"
export default component.exports